'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-dom-server.browser.production.min.js');
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/server.browser.js
 ** module id = 778
 ** module chunks = 0
 **/